<app-dossier
  eyebrow="Dossier agent // Lobby de mission"
  [reference]="operation.value()?.codeName ?? null"
>
  <app-page-title title="Salle de briefing" lede="En attente du lancement de la mission" />

  @if (operation.value(); as operation) {
    @if (operation.startsAt; as startsAt) {
      <app-countdown [until]="startsAt" label="Lancement prévu dans" />
    }

    <h2 class="section-label">État de la partie</h2>
    <app-game-status status="En attente" [counts]="counts()" [lobby]="true">
      La mission débutera au signal de l'organisateur.<br />Votre cible vous sera alors révélée.
    </app-game-status>

    <div class="spaced">
      <app-roster
        [entries]="operation.ranking"
        [selfCodeName]="selfCodeName()"
        [count]="counts().total + ' agents'"
      />
    </div>
  } @else if (loadError(); as message) {
    <app-state-panel kind="error" title="Transmission impossible" [message]="message">
      <button
        class="button button--secondary"
        type="button"
        (click)="mission.reload(); operation.reload()"
      >
        Réessayer
      </button>
    </app-state-panel>
  } @else {
    <app-state-panel
      kind="loading"
      title="Liaison avec le QG…"
      message="Récupération de votre dossier."
    />
  }

  <div class="note">
    <p>Restez en alerte. Ne partagez aucune information sensible.</p>
    <p class="accent">La réussite de la mission dépend de votre discrétion.</p>
  </div>

  <p class="center dossier__footer">
    <button class="button button--link" type="button" (click)="confirmingLeave.set(true)">
      Quitter la salle de briefing
    </button>
  </p>

  <app-confirm-dialog
    [open]="confirmingLeave()"
    title="Quitter la salle de briefing ?"
    confirmLabel="Quitter"
    cancelLabel="Rester"
    [busy]="leaving()"
    (confirmed)="leave()"
    (cancelled)="confirmingLeave.set(false)"
  >
    <p>
      Votre dossier sera détruit : vous disparaîtrez de la fiche d'effectif et votre nom de code
      @if (selfCodeName(); as codeName) {
        <strong>{{ codeName }}</strong>
      }
      sera libéré.
    </p>
    <p>Pour revenir, il faudra vous inscrire à nouveau, tant que l'opération n'a pas commencé.</p>
    @if (leaveError(); as message) {
      <p class="field__error" role="alert">{{ message }}</p>
    }
  </app-confirm-dialog>
</app-dossier>
